"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const styles_1 = __importDefault(require("../../styles"));
const lodash_1 = __importDefault(require("lodash"));
const $btn = 'f6 link dim bn br2 ph3 pv2 mr2 dib white bg-dark-blue';
const getFiles = field => (e) => {
    e.preventDefault();
    console.log(field.name, '>> getFiles', lodash_1.default.map(field.files));
};
const createPreview = (file) => {
    // eslint-disable-next-line
    file.preview = window.URL.createObjectURL(file);
    return file.preview;
};
const destroyPreview = (file, field) => (e) => {
    e.preventDefault();
    // eslint-disable-next-line
    window.URL.revokeObjectURL(file.preview);
    // eslint-disable-next-line
    console.log('file.preview', file.preview);
    // remove file from array
    const index = field.files.indexOf(file);
    (0, mobx_1.action)(() => field.files.splice(index, 1))();
};
exports.default = (0, mobx_react_1.observer)(({ field, multiple = false, }) => (react_1.default.createElement("div", null,
    react_1.default.createElement("input", Object.assign({}, field.bind({ id: 'files-input' }), { multiple: multiple, className: "dn" })),
    react_1.default.createElement("label", { htmlFor: "files-input", className: $btn }, "Select File..."),
    react_1.default.createElement("button", { onClick: getFiles(field), className: styles_1.default.ctrl }, "Get Files"),
    (field.files && field.files.length) ? react_1.default.createElement("div", null,
        react_1.default.createElement("h2", null,
            "Uploading ",
            field.files.length,
            " files..."),
        react_1.default.createElement("div", null, field.files.map(file => react_1.default.createElement("button", { key: file.name, onClick: destroyPreview(file, field), className: styles_1.default.ctrl },
            react_1.default.createElement("img", { className: "w-10 h-10", src: createPreview(file), alt: file.name }))))) : null)));
